import { render, staticRenderFns } from "./CrmStatusSelect.vue?vue&type=template&id=99e1ccd2"
import script from "./CrmStatusSelect.vue?vue&type=script&lang=ts"
export * from "./CrmStatusSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports